import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-539dc36f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "pr-[20px]" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "ml-[80px] mt-[60px] mr-[120px]" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[24px] font-bold mb-[30px]" }, "广晟直通车", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[24px] text-[var(--el-color-primary)] mb-[5px]" }, "所有广晟机会全网首发", -1))

import {
    ArrowRight,
} from '@element-plus/icons-vue'
import { ref, watch, withDefaults } from 'vue'
import { getPage } from "@/http/api";
import { IList } from '@/interface/article';
import useNavigation from '@/hooks/useNavigation';

interface IResult {
    data: Array<IList>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'JobRequirements',
  props: {
    logo: { default: '' },
    id: { default: '' }
  },
  setup(__props: any) {

const { push } = useNavigation()
const props = __props

const list = ref<Array<{ title: string, id: string | number }>>([])
watch(() => props.id, (val) => {
    if (val) {
        getSelPage(val)
    }
}, { immediate: true })
function getSelPage(menuId, pageNum = 1) {
    getPage<IResult>({
        menuId,
        pageNum,
        pageSize: 20,
    }).then((res) => {
        list.value = (res.rows as any) || [];
    });
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "doc",
          key: item.id,
          onClick: ($event: any) => (_unref(push)({
                path: '/news/detail', query: { id: item.id, }
            }))
        }, _toDisplayString(item.title), 9, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "block w-[305px]",
        src: _ctx.logo,
        alt: ""
      }, null, 8, _hoisted_5),
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_el_button, {
        class: "bg-[var(--el-color-primary)]",
        type: "primary",
        round: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 我要参加"),
          _createVNode(_component_el_icon, { class: "el-icon--right ml-[30px]" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowRight))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})